export const LOAN_PARTNER = {
    cic: {
        en: 'CIC',
        es: 'CIC'
    },
    cfb: {
        en: 'Community Food Bank',
        es: 'Banco Comunitario de Alimentos'
    },
    ywca: {
        en: 'YWCA',
        es: 'YWCA'
    }
} as Record<string, { en: string; es: string }>;
